const StartPaymentMethodSession = ({ metroidAuthToken = '', businessUnit = '', zuoraUserToken = '' } = {}) => ({
  metroidAuthToken: String(metroidAuthToken),
  businessUnit: String(businessUnit),
  zuoraUserToken: String(zuoraUserToken),
});

export default StartPaymentMethodSession;

export type StartPaymentMethodSessionProps = ReturnType<typeof StartPaymentMethodSession>;
